module.exports = __webpack_public_path__ + "img/201604-3-1024x1024.5a97bc13.jpg";